/**
 * Branding utility for custom event branding
 * When eventId === "1745879876", use XTravex branding instead of Eventegration
 */

export const XTRAVEX_EVENT_ID = "1745879876";

export const getBranding = (eventId) => {
  const isXTravex = eventId === XTRAVEX_EVENT_ID;

  return {
    isXTravex,
    companyName: isXTravex ? "XTravex" : "Eventegration",
    websiteUrl: isXTravex
      ? "https://xtravex.com/"
      : "https://eventegration.com",
    logoUrl: isXTravex
      ? "https://api-admin.eventegration.com/public/logo/1745879876.png?t=1766999775406"
      : null, // null means use default logo
  };
};

export const getPoweredByText = (eventId) => {
  const branding = getBranding(eventId);
  return `Powered by ${branding.companyName}`;
};
